( function( $ ) {
    $(document).ready(function(){

        var parseLink = function(link) {

            link_href = $(link).attr('href');

            link_regex = /merinfo\/([0-9]*)\/([a-zA-Z0-9_]*)\/([0-9]*)/gi;

            tracking_params = link_regex.exec( link_href );

            product_id = tracking_params[1];
            placeholder = tracking_params[2];
            pos = parseInt( tracking_params[3], 10 );

            if( typeof $(link).data('name') !== 'undefined' ) {

                product = $(link).data('name');

            } else {

                product = product_id;
            }

            return { 'product' : product, 'placeholder' : placeholder, 'pos' : pos };

        };

        $.tracked_placeholders = [];

        $('.toplist-wrap').on('click','a[href*="merinfo/"]', function(e) {
            //console.log('In ga Click Function');
            link_params = parseLink( this );

            if ( typeof ga !== 'undefined') {
                ga('send', {
                    'hitType': 'event',          // Required.
                    'eventCategory': link_params.placeholder,   // Required.
                    'eventAction': 'Click',      // Required.
                    'eventLabel': link_params.product,
                    'eventValue': link_params.pos
                });

            }

        });
        
        $('.private-loan-ui ').on('click', 'input[type=submit]', function(e){
            if ( typeof ga !== 'undefined') {
                ga('send', {
                    'hitType': 'event',          // Required.
                    'eventCategory': 'Form',   // Required.
                    'eventAction': 'Click',      // Required.
                    'eventLabel': $('#ListID').val(),
                    'eventValue': 1
                });

            }
        });

    });
} )( jQuery );